import { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import config from 'constants/config'

function usePersonalPortalHref(): string {
  const { currentRegionCode } = useContext(GeoContext)
  const personalPortalHref =
      `${config.businessTraveller.personalPortalHref}/${currentRegionCode}`

  return personalPortalHref
}

export default usePersonalPortalHref
